module.exports = __webpack_public_path__ + "static/media/5.566b515a.jpg";